export function getVictimStatusFromVictimInfo (victimInfo) {
    if (!victimInfo || !victimInfo.length) {
        return 'Pending'
    }

    const victimStatusByPriority = {
        'Yes': 1,
        'Suspected': 2,
        'At-Risk': 3,
        'Unknown': 4,
        'Other': 4
    }

    const victimStatuses = victimInfo
        .map((victim) => victim.b_confirmed)
        .filter((victimStatus) => victimStatus)
        .sort((a, b) => victimStatusByPriority[a] - victimStatusByPriority[b])

    const isVictimPending = victimInfo
        .filter((victim) => victim.b_mdt_status === 'Pending').length > 0

    return isVictimPending ? 'Pending' : (victimStatuses[0] || '')
}



// WEBPACK FOOTER //
// ./src/helpers/victiminfo.js